<template>
  <div class="kye-report-fzkp005">
    <div
      v-for="(card, index) in data"
      class="fzkp005_main-cell"
      :class="[value === index ? 'kye-report-fzkp005-selected' : '', `fzkp005_main-cell-${index}`]"
      :key="index"
      @click="cardClick(index)"
    >
      <div class="fzkp005_main-cell-title">
        <span
          class="fzkp005_main-title"
          @click="handleClick('mainTitle', index)"
          v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', index, card.mainTitle]}"
        >{{card.mainTitle}}</span>
        <KyeReportCardQuestion
          class="fzkp005_main-icon"
          :icon="card.mainIcon"
          :popover="card.popover"
          @click="handleClick('mainIcon', index)"
        >
          <slot :name="'tooltip'+index"></slot>
        </KyeReportCardQuestion>
      </div>
      <div class="fzkp005_main-cell-index">
        <span
          class="fzkp005_main-index"
          @click="handleClick('mainIndex', index)"
          v-events="{ eventsMap, ignoreEventName, args: ['mainIndex', index, card.mainIndex]}"
        >{{card.mainIndex}}</span>
        <div class="fzkp005_order-cell-icon" :class="getIndexColor(card.orderIcon2)">
          <img
            class="fzkp005_order-icon1"
            :src="data.orderIcon1 || mainIcon1"
            @click="handleClick('orderIcon1', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['orderIcon1', index, card.orderIcon1]}"
          />
          <span
            class="fzkp005_order-index"
            @click="handleClick('orderIndex', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['orderIndex', index, card.orderIndex]}"
          >{{card.orderIndex}}</span>
          <kyeReportCardArrow
            v-events="{ eventsMap, ignoreEventName, args: ['orderIcon2', index, card.orderIcon2]}"
            @click="handleClick('orderIcon2', index)"
            class="fzkp005_order-icon2"
            :type="card.orderIcon2"
          ></kyeReportCardArrow>
        </div>
      </div>
    </div>
     <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/fzkp004-01.png'
import kyeReportCardArrow from '../common/arrow.vue'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportFzkp005',
  components: {
    KyeReportCardQuestion,
    kyeReportCardArrow
  },
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: Number
    }
  },
  data() {
    return {
      mainIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    },
    cardClick(index) {
      this.$emit('cardClick', index, this.data)
      this.$emit('input', index)
    },
    getIndexColor(type) {
      if (type === 'up') {
        return 'index-up-color'
      } else if (type === 'down') {
        return 'index-down-color'
      }
    }
  }
}
</script>
<style lang="scss">
.kye-report-fzkp005 {
  @import '../../style/extend.scss';
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  background: linear-gradient(180deg, #FFF2F4 0%, #FFFFFF 50%);
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  // padding: 15px 0 12px 0;
  &-selected {
    background: linear-gradient(180deg, #F2F1FF 0%, #FFFFFF 100%);
    &::after {
      position: absolute;
      top: -1px;
      left: 0;
      right: 0;
      height: 2px;
      background: var(--g-color-primary);
      content: '';
    }
  }
  .fzkp005_main-cell {
    flex: 1;
    padding: 15px 16px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    &:not(:last-child) {
      &::before {
        position: absolute;
        top: 12px;
        right: 0;
        bottom: 12px;
        width: 1px;
        background: #EBEDF5;
        content: '';
      }
    }
    .fzkp005_main-cell-title {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .fzkp005_main-title {
      font-size: 12px;
      font-weight: normal;
      line-height: 12px;
      letter-spacing: 0px;
      color: #333333;
    }
    .fzkp005_main-cell-index {
      display: flex;
      align-items: center;
      gap: 8px;
      .fzkp005_main-index {
        font-size: 18px;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0em;
        color: var(--g-color-primary);
      }
      .fzkp005_order-cell-icon {
        display: flex;
        align-items: center;
        flex: 1;
        gap: 4px;
        .fzkp005_order-index {
          font-size: 12px;
          font-weight: normal;
          line-height: 12px;
          letter-spacing: 0px;
        }
        .fzkp005_order-icon1 {
          width: 11px;
          height: 11px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/fzkp005/index.vue